import { useEffect, useRef } from "react";
import JsBarcode from 'jsbarcode';
import "./generateBarcode.scss"

const Index = ({ item }: { item: { bar_code: string } }) => {
  const barcodeRef = useRef(null);

  const textStyle = {
    fontSize: '7.5px',
    fontFamily: 'monospace',
    letterSpacing: `0.9em`, // Example spacing
    display: 'flex',
    justifyContent: 'center',
    m: 0,
    p: 0
  };

  useEffect(() => {
    if (barcodeRef.current && item?.bar_code) {
      JsBarcode(barcodeRef.current, item.bar_code, {
        format: 'CODE128',
        lineColor: '#000',
        width: 1,
        height: 14,
        displayValue: false,
        fontSize: 6,
        margin: 0,
        marginBottom: 2,
      });
    }
  }, [item]);

  return (
    <div className="barcode-wrapper">
      <div className="barcode-text">
        {item.bar_code.split('').map((digit, index) => (
          <span key={index} className="barcode-digit">{digit}</span>
        ))}
      </div>
      <svg ref={barcodeRef} className="barcode-svg" />
    </div>
  )
}

export default Index